'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import tkns from '@lualtek/tokens/web/tokens.json';
import clsx from 'clsx';
import { domMax, LazyMotion, m } from 'motion/react';
import { forwardRef, useId, useMemo, } from 'react';
import { AutoFocusInside, FocusOn } from 'react-focus-on';
import { useKey } from 'react-use';
import { Elevator, IconButton, Overlay, Panel, Stack, Title, useResponsiveContext, } from '../../index.js';
import styles from './drawer.module.css';
/**
 * @deprecated This component is outdated. Use `Sheet` instead.
 */
export const Drawer = forwardRef(({ children, className, closeOnClickOutside = true, showHeader = true, compactHeader = false, maxWidth = '400px', side = 'right', theme = 'auto', isModal = true, autoFocus = true, safePadding = true, heading, onClose, isOpen, index, scrollerRef, ...otherProps }, forwardedRef) => {
    const headingId = useId();
    const { matches } = useResponsiveContext();
    useKey('esc', () => onClose());
    const dynamicStyle = useMemo(() => ({
        '--max-w': maxWidth,
    }), [maxWidth]);
    const DrawerAnimation = {
        visible: {
            x: 0,
            transition: {
                type: 'spring',
                bounce: 0,
                duration: parseFloat(tkns.duration[500].replace('s', '')),
            },
        },
        hidden: {
            x: side === 'right' ? '100%' : '-100%',
            transition: {
                type: 'spring',
                bounce: 0,
                duration: parseFloat(tkns.duration[500].replace('s', '')),
            },
        },
    };
    return (_jsx(Overlay, { obfuscate: isModal, onClose: onClose, index: index, children: isOpen && (_jsx("div", { role: "dialog", "aria-modal": isModal, "data-theme": theme, "aria-labelledby": headingId, className: clsx(styles.Drawer, className), ref: forwardedRef, ...otherProps, children: _jsx(FocusOn, { enabled: isModal, onClickOutside: closeOnClickOutside ? onClose : undefined, onEscapeKey: onClose, autoFocus: autoFocus, children: _jsx(LazyMotion, { features: domMax, children: _jsx(m.div, { variants: DrawerAnimation, initial: "hidden", animate: "visible", exit: "hidden", className: styles.Container, "data-drawer-side": side, children: _jsx(Elevator, { resting: 4, direction: side === 'left' ? 'right' : 'left', children: _jsx(Panel, { vibrant: true, vibrancyColor: "soft", showGlow: matches.small, bordered: true, borderSide: side === 'left' ? 'right' : 'left', children: _jsxs(Stack, { className: styles.Content, style: dynamicStyle, fill: false, vAlign: "start", ref: forwardedRef, "data-drawer-content-safe-padding": safePadding, "data-drawer-has-header": showHeader, "data-drawer-compact-header": compactHeader, ...otherProps, children: [(showHeader && heading) && (_jsxs(Stack, { vAlign: "center", hAlign: "space-between", direction: "row", className: styles.Header, columnGap: 24, children: [_jsx(Title, { responsive: false, level: "5", id: headingId, lineHeight: "small", children: heading }), onClose && (_jsx(IconButton, { onClick: onClose, className: styles.CloseButton, icon: "remove", kind: "flat" }))] })), _jsx("div", { className: styles.Scroller, ref: scrollerRef, children: _jsx(AutoFocusInside, { children: children }) })] }) }) }) }) }) }) })) }));
});
